/* ADD GROUPS */
export const LIST_QUIZZ_ANSWERS = "LIST_QUIZZ_ANSWERS"
export const LIST_QUIZZ_ANSWERS_SUCCESS = "LIST_QUIZZ_ANSWERS_SUCCESS"
export const LIST_QUIZZ_ANSWERS_CLEAN = "LIST_QUIZZ_ANSWERS_CLEAN"
export const LIST_QUIZZ_ANSWERS_ERROR = "LIST_QUIZZ_ANSWERS_ERROR"
